import { LinearProgress, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import {
	ComputerOutlined,
	MemoryOutlined,
	PersonOutlineOutlined,
	Power,
	PowerOutlined,
	RouterOutlined,
} from "@mui/icons-material";

export default function CardStatusHealth(params) {
	const {
		valueCard = "",
		titleCard = "",
		typeCard = 1,
		loading = false,
	} = params;

	const theme = useTheme();
	const styles = useStyles(theme);

	const iconComponents = {
		1: PowerOutlined,
		2: ComputerOutlined,
		3: MemoryOutlined,
		4: RouterOutlined,
	};
	const colorBoxIcon = {
		1: theme.palette.colors.green.light,
		2: theme.palette.colors.purple.medium,
		3: theme.palette.colors.blue.medium,
		4: theme.palette.colors.orange.medium,
	};
	const colorIcon = {
		1: theme.palette.colors.green.light,
		2: theme.palette.colors.purple.medium,
		3: theme.palette.colors.blue.medium,
		4: theme.palette.colors.orange.medium,
	};
	const cardGradient = {
		1: theme.palette.gradient.cardStatusHealthTime,
		2: theme.palette.gradient.cardStatusHealthSystem,
		3: theme.palette.gradient.cardStatusHealthFirmware,
		4: theme.palette.gradient.cardStatusHealthDevice,
	};

	const IconComponent = iconComponents[typeCard];
	return (
		<Paper
			elevation={theme.palette.mode === "dark" ? 0 : 3}
			sx={{
				...styles.containerPaper,
				backgroundImage: cardGradient[typeCard],
			}}
		>
			<Box
				elevation={0}
				sx={{
					...styles.boxLayout,
					backgroundColor: colorBoxIcon[typeCard],
				}}
			/>
			{loading && <LinearProgress sx={styles.linearProgress} />}
			<IconComponent sx={{ ...styles.icon, color: colorIcon[typeCard] }} />
			<Typography sx={styles.titleCard}>{titleCard}</Typography>
			<Typography sx={{ ...styles.valueCard, color: colorIcon[typeCard] }}>
				{valueCard}
			</Typography>
		</Paper>
	);
}
